import React, { useState } from "react";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import Divider from "@mui/material/Divider";
import { Box, Avatar, Menu, MenuItem, IconButton } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import utilFunctions from "../../../utilities/utilFunctions";
import { useNavigate, useParams } from "react-router-dom";
import CopySpecRecipeModal from "../../../components/Modals/CopySpecRecipeModal";

const SpecRecipeListItem = ({ recipe, handleCopyRecipe }) => {
  const navigate = useNavigate();
  const { establishmentid } = useParams();
  const [anchorEl, setAnchorEl] = useState(null);
  const [copyModalOpen, setCopyModalOpen] = useState(false);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleCopyModalOpen = () => {
    setCopyModalOpen(true);
    handleMenuClose();
  };

  return (
    <>
      <ListItem
        disableGutters
        sx={{ backgroundColor: (theme) => theme.palette.pure.white }}
        secondaryAction={
          <IconButton onClick={handleMenuClick}>
            <MoreHorizIcon />
          </IconButton>
        }
      >
        <ListItemButton
          onClick={() =>
            navigate(`/spec/${establishmentid}/spec-recipes/${recipe.id}`)
          }
        >
          {recipe.imageUrl ? (
            <Avatar
              variant="rounded"
              sx={{
                zIndex: 1,
                width: "32px",
                height: "32px",
                resize: "contain",
                alignSelf: "center",
              }}
              src={recipe.imageUrl}
            />
          ) : (
            <Box
              sx={{
                zIndex: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "32px",
                height: "32px",
                border: "1px solid",
                borderColor: (theme) => theme.palette.terrain[400],
                borderRadius: "15%",
                overflow: "hidden",
              }}
            >
              <AddPhotoAlternateOutlinedIcon sx={{ fontSize: "12px" }} />
            </Box>
          )}

          <ListItemText
            primary={utilFunctions.capitalizeString(recipe.name)}
            sx={{ marginLeft: 4 }}
          />
        </ListItemButton>
      </ListItem>
      <Divider />
      <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        <MenuItem onClick={handleCopyModalOpen} sx={{ margin: "5px" }}>
          <ContentCopyIcon sx={{ marginRight: "5px" }} />
          Copy to My Recipes
        </MenuItem>
      </Menu>
      <CopySpecRecipeModal
        copyRecipe={handleCopyRecipe}
        isOpen={copyModalOpen}
        toggleModalOpen={() => setCopyModalOpen(!copyModalOpen)}
        recipeName={recipe?.name}
        recipeId={recipe?.id}
      />
    </>
  );
};

export default SpecRecipeListItem;
